import AliceHappTre from './AliceHappTre.jpg';
import AnnaSvedbergStenaLine from './AnnaSvedbergStenaLine.jpg';
import JohanSkarinAgreat from './JohanSkarinAgreat.jpg';
import kimonSfirisSigma from './kimonSfirisSigma.jpg';
import MartinAnderssonWirelessCar from './MartinAnderssonWirelessCar.jpg';

export const testimonialImages = {
  AliceHappTre,
  AnnaSvedbergStenaLine,
  JohanSkarinAgreat,
  kimonSfirisSigma,
  MartinAnderssonWirelessCar,
};
